import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { BsXLg } from "react-icons/bs";

import CharCard from "./CharCard.js";
import ItemCard from "./ItemCard.js";

export default function ItemModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function goToPlaceAndChar (placeId, charId)
    {
	if (gData.state.currentPlaceId !== placeId || ! gData.state.showModals.dialogue) gDispatch({ type: "goToPlaceAndChar", placeId, charId });
	gDispatch({ type: "closeModal", modal: "items" });
    }

    function closeItems ()
    {
	gDispatch({ type: "closeModal", modal: "items" });
    }

    const charCards = Object
	.values(gData.content.chars)
	.filter((char) => char.placeId !== null)
	.sort((char1, char2) => {
	    const charQuest1 = gData.state.charQuests[char1.id];
	    const charQuest2 = gData.state.charQuests[char2.id];
	    const found1 = charQuest1 !== undefined && charQuest1.state === "opened";
	    const found2 = charQuest2 !== undefined && charQuest2.state === "opened";

	    if (found1 && found2) return charQuest1.time - charQuest2.time;
	    else if (found1) return -1;
	    else if (found2) return +1;
	    else return 0;
	})
	.map((char) => {
	    const charQuest = gData.state.charQuests[char.id];
	    const found = charQuest !== undefined && charQuest.state === "opened";

	    if (found)
	    {
		return (
		    <div key={char.id} style={{ width: "30%" }} onClick={() => { goToPlaceAndChar(char.placeId, char.id) }}>
			<CharCard charId={char.id} pictureWidth="100%"/>
		    </div>
		);
	    }
	    
	    else {
		return (
		    <div key={char.id} style={{ width: "30%" }}>
			<CharCard charId={null} pictureWidth="100%"/>
		    </div>
		);
	    }
	});


    const infoCards = Object
	.values(gData.state.items)
	.filter((item) => {
	    const itemContent = gData.content.items[item.id];
	    return itemContent.themeId === gData.state.currentThemeId && itemContent.type === "info";
	})
	.sort((item1, item2) => {
	    if (item1.found && item2.found) return item1.time - item2.time;
	    else if (item1.found) return -1;
	    else if (item2.found) return +1;
	    else return 0;
	})
	.map((item) => {
	    const itemContent = gData.content.items[item.id];
	    if (item.found) return (<ItemCard key={item.id} itemId={item.id} placement="top"/>);
	    else return (<ItemCard key={item.id} itemId={null} type={itemContent.type}/>);
	});

    const bpCards = Object
	.values(gData.state.items)
	.filter((item) => {
	    const itemContent = gData.content.items[item.id];
	    return itemContent.themeId === gData.state.currentThemeId && itemContent.type === "bp";
	})
	.sort((item1, item2) => {
	    if (item1.found && item2.found) return item1.time - item2.time;
	    else if (item1.found) return -1;
	    else if (item2.found) return +1;
	    else return 0;
	})
	.map((item) => {
	    const itemContent = gData.content.items[item.id];
	    if (item.found) return (<ItemCard key={item.id} itemId={item.id} placement="left"/>);
	    else return (<ItemCard key={item.id} itemId={null} type={itemContent.type}/>);
	});

    const indiceCards = Object
	.values(gData.state.items)
	.filter((item) => {
	    const itemContent = gData.content.items[item.id];
	    return itemContent.themeId === gData.state.currentThemeId && itemContent.type === "indice";
	})
	.sort((item1, item2) => {
	    if (item1.found && item2.found) return item1.time - item2.time;
	    else if (item1.found) return -1;
	    else if (item2.found) return +1;
	    else return 0;
	})
	.map((item) => {
	    const itemContent = gData.content.items[item.id];
	    if (item.found) return (<ItemCard key={item.id} itemId={item.id} placement="bottom"/>);
	    else return (<ItemCard key={item.id} itemId={null} type={itemContent.type}/>);
	});


    return (
	<Modal
	    dialogClassName="modal-xxl overflow-hidden user-select-none"
	    contentClassName="modal-content-xxl overflow-hidden border border-secondary"
	    show={gData.state.showModals.items && ! gData.state.showModals.end}
	onHide={closeItems}
	scrollable={true}
	    centered
	backdrop={gData.state.showModals.dialogue ? true : "static"}
        keyboard={! gData.state.showModals.dialogue}
	>
	<Modal.Header className="bg-black text-light d-flex align-items-center justify-content-between bg-light">
	    <Button className="invisible"><BsXLg/></Button>
	    <Modal.Title className="fs-3 text-uppercase fw-bold" style={{ textShadow: "#AAF 1px 1px 10px" }}>Notes d'enquête</Modal.Title>
	    <Button variant="light" className={gData.state.showModals.dialogue ? "" : "invisible"} onClick={closeItems}><BsXLg/></Button>
	</Modal.Header>
	    <Modal.Body className="mt-3 mb-4">
		<Row>
		    <Col md={4} className="text-center">
			<span className="fs-4 text-uppercase"><span className="fw-bold">suspects</span> à interroger</span>
			<div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
			    {charCards}
			</div>
		    </Col>
		    <Col md={4} className="text-center">
			<div className="d-flex flex-column justify-content-center gap-2">
			    <span className="fs-4 text-uppercase"><span className="fw-bold">Indices</span> collectés</span>
			    {indiceCards}
			</div>
			<div className="d-flex flex-column justify-content-center gap-2 mt-4">
			    <span className="fs-4 text-uppercase"><span className="fw-bold">Informations</span> collectées</span>
			    {infoCards}
			</div>
		    </Col>
		    <Col md={4} className="text-center">
			<div className="d-flex flex-column justify-content-center gap-2">
			    <span className="fs-4 text-uppercase"><span className="fw-bold">Conseils</span> collectés</span>
			    {bpCards}
			</div>
		    </Col>
		</Row>
	    </Modal.Body>
	</Modal>
    );
}
